<!-- todo: localize tooltip newExp -->
<div
  *ngIf="action === 'expand'"
  class="p-6px h-28px hov-cursor-p grey-80-v2 hov-ink-80-v3"
  (click)="expandNav(true)"
  ui-tooltip
  [tooltipContent]="'Open side bar' | localize"
  tooltipPosition="bottomLeft">
  <div class="gh-font-icon-close-menu fs-16px rotated"></div>
</div>
<div
  *ngIf="action === 'collapse'"
  class="p-6px h-28px hov-cursor-p grey-80-v2 hov-ink-80-v3"
  (click)="expandNav(false)"
  ui-tooltip
  [tooltipContent]="'Close side bar' | localize"
  tooltipPosition="bottomLeft">
  <div class="gh-font-icon-close-menu fs-16px"></div>
</div>
